import { useDisclosure } from "@heroui/react";
import { ModalBuilder, ModalError, ModalField } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import { getIdFromCategoryHandbook } from "@/utils/getIdFromHandbooks.ts";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { loadHandbooks } from "@/utils/loadHandbooks";
import { CodependentCategoryHandbook } from "../../handbooks/categoryHandbook";

interface CreateToPlatformTicketForm {
  subject: string;
  category: number;
  priority: "low" | "medium" | "high" | "urgent";
}

const createToPlatformTicketFields: ModalField[] = [
  {
    label: "hid",
    name: "to_platform",
    placeholder: "-",
    type: "hidden",
  },
  {
    label: "Тема обращения",
    name: "subject",
    placeholder: "Введите тему обращения",
    type: "text",
    isRequired: true,
  },
  {
    label: "Категория",
    name: "category",
    placeholder: "",
    type: "codependent",
    deps: ["to_platform"],
    element: CodependentCategoryHandbook,
    isRequired: true,
  },
];

export function CreateToPlatformTicketModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: CreateToPlatformTicketForm) => {
    return new Promise<boolean>((resolve) => {
      getIdFromCategoryHandbook(String(data.category))
        .then((category) => {
          return api.tickets.create({
            subject: data.subject,
            type: "to_platform",
            category: Number(category),
            status: "open",
            priority: data.priority,
          });
        })
        .then(() => {
          loadHandbooks({ handbooks: ["ticketCategories"] });
          disclosure.onClose();
          toast.success("Тикет успешно создан");
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание тикета к платформе"
      modalErrors={modalErrors}
      fields={createToPlatformTicketFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
      defaultValues={{
        to_platform: "to_platform",
      }}
    />
  );
}
